import React, { useEffect, useState } from 'react';
import useCheckSignOff from '../hooks/useCheckSignOff';
import { getLocalTodayString } from '../../../components/CreationDate';

export default function CheckSignOff({ checklistId, creationDate = getLocalTodayString(), fields, slug, label = 'Submit for sign-off' }) {
    const [approved, setApproved] = useState(false);
    const { canSubmit, isSubmitting, submit, submission } = useCheckSignOff({ checklistId, creationDate, approved, fields, slug });
    useEffect(() => { setApproved(false); }, [checklistId, creationDate, slug]);
    useEffect(() => { setApproved(submission?.isClosedSecured === true); }, [submission?.isClosedSecured]);
    return (
        <div className="flex flex-col gap-3">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">
                <input type="checkbox" checked={approved} disabled={isSubmitting} onChange={event => setApproved(event.target.checked)} />
                Approve
            </label>
            <button type="button" onClick={submit} disabled={!canSubmit}
                className="rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed">
                {isSubmitting ? 'Submitting...' : label}
            </button>
        </div>
    );
}
